








































import { defineComponent } from "@vue/composition-api";
import PlaceCard from "@c/molecules/place/PlaceCard.vue";
import PrimaryContentBody from "@/vue/layouts/PrimaryContentBody.vue";
import CreateButton from "@c/atoms/app/CreateButton.vue";
import useFetcher from "@/ts/functions/composition/useFetcher";

export default defineComponent({
  name: "MyPlaces",

  components: {
    PlaceCard,
    PrimaryContentBody,
    CreateButton
  },

  setup() {
    var { entity: places, loading: loading } = useFetcher(
      "place/GET_USER_PLACES"
    );

    return {
      places,
      loading
    };
  }
});
